export default ({ app, route, redirect }) => {
  const { query, path } = route

  if (query?.preview && !['/login/', '/preview/'].includes(path)) {
    return redirect(app.localePath({ name: 'preview', query }))
  }
}
